<div>
  <span>Techstreet PTY LTD</span><br/>
  <span>Locked Bag 777 Collins Street</span><br/>
  <span>West Post Office, Vic 8007 AUSTRALIA</span><br/>
  <span>Phone: +1 800 845 140 | +61 2 9161 7799</span><br/>
  <span>E-mail: store&#64;techstreet.com</span><br/>
  <span>Website: www.techstreet.com.au</span>
</div>
